// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__9-TqB","colCheckbox":"styles_colCheckbox__2IxQ8"};